export default "__VITE_ASSET__UYEl7pmw__"